import { DialogProps } from '@mui/material';
import React, { FC, ReactNode } from 'react';
import { BootstrapDialogTitle, DialogWrapper, PaperComponent } from '.';

interface IModalProps extends DialogProps {
  modalTitle?: ReactNode
  draggable?: boolean
  onCloseBtnClick?: () => void
}
export const Modal: FC<IModalProps> = (props) => {
  const { modalTitle, children, draggable = true, onCloseBtnClick, ...dialogProps } = props;
  return (
    <DialogWrapper
      {...dialogProps}
      PaperComponent={PaperComponent}
    >
      <BootstrapDialogTitle
        id={draggable ? 'draggable-dialog-title' : ''}
        onClose={onCloseBtnClick}
        style={{ cursor: draggable ? 'move' : 'auto' }}
      >{modalTitle || ''}</BootstrapDialogTitle>
      {children}
    </DialogWrapper>
  );
};
